import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalexpercommentbacktbn from './Modalexpercommentbacktbn';
import Modalexpercommentbacktbnforex from './Modalexpercommentbacktbnforex';



export default class Commentbnlistfromex extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   expert_id:'',
   commentbn:[],
   commentbnfromex:[],
   
}


//this.handleSubmit = this.handleSubmit.bind(this);

this.toggle = this.toggle.bind(this);
this.list = this.list.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()
;  this.props.selectex();
}


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ id_send:this.props.id_send,
                       expert_id:this.props.expert_id,
         })
      setTimeout(() => {
       
         Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectcommentforbnfromex.php?idexpert='+this.props.expert_id+'&id_send='+this.props.id_send)
        .then(res => {
          console.log(res);
       
          this.setState({ commentbnfromex: res.data})
        }) 

      }, 0);

  }

  list() {
 
      setTimeout(() => {
         Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectcommentforbnfromex.php?idexpert='+this.props.expert_id+'&id_send='+this.props.id_send)
        .then(res => {
          console.log(res);
          this.setState({ commentbnfromex: res.data})
        }) 

      }, 0);

  }



    render() {
        

        return (
            <>
           <MDBTable>
      <MDBTableHead  >
        <tr>
          <th>ลำดับ</th>
          <th>ไฟล์บทความ</th>
          <th>วันที่</th>
          <th>ไฟล์ข้อเสนอแนะ</th>
          <th>วันที่ส่งกลับ</th>
          <th>สถานะ ผ่าน/ไม่ผ่าน</th>
          <th>การส่งกลับ</th>
          
        </tr>
      </MDBTableHead>
      <MDBTableBody>
                      {this.state.commentbnfromex.map((commentbnfromex,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        {/* <td>{commentbnfromex.fileword}</td> */}
                        <td>{commentbnfromex.fileword !== null ? <>
                            <a href={`https://edu.kpru.ac.th/conference/PHPAPI/closeacticleex/${commentbnfromex.fileword}`}  target="_blank"><p className="green-text"><MDBIcon far icon="file-word" /> ไฟล์บทความ</p> </a>
                           </>:<><MDBIcon far icon="hourglass" /></>}</td>
                        <td>{commentbnfromex.date_sentex}</td>
                        {/* <td>{commentbnfromex.filepdfcomment_ex !== null ? <>{commentbnfromex.filepdfcomment_ex}</>:<><MDBIcon far icon="hourglass" /></>}</td> */}
                        <td>{commentbnfromex.filepdfcomment_ex !== null ? <>
                            <a href={`https://edu.kpru.ac.th/conference/PHPAPI/commentex/${commentbnfromex.filepdfcomment_exclose}`}  target="_blank"><p className="green-text"><MDBIcon far icon="file-word" /> ไฟล์ข้อเสนอแนะ</p> </a>
                           </>:<><MDBIcon far icon="hourglass" /></>}</td>
                        <td>{commentbnfromex.date_senbacktex !== null ?<>{commentbnfromex.date_senbacktex}</>:<><MDBIcon far icon="hourglass" /></>}</td>
                        <td>{commentbnfromex.statuscomment_ex==='1'?<>ผ่าน</>:<>
                               {commentbnfromex.statuscomment_ex==='0'?<>ไม่ผ่าน</>:<><MDBIcon far icon="hourglass" /></>}
                            </>}
                        </td>
                        <td>
                            {commentbnfromex.filepdfcomment_ex !== null ?<>
                        ส่งกลับแล้ว
                        </>:<>
                          {commentbnfromex.statuscomment_ex==='1'?<>แจ้งกลับแล้ว</>:<>
                          <Modalexpercommentbacktbnforex id_send={commentbnfromex.id_send} id_excomment={commentbnfromex.id_excomment} id_bn={commentbnfromex.id_bn}  id_ex={commentbnfromex.id_ex} list={this.list}  />
                          </>}
                        </>}
                        {}
                            
                            </td>
                        </tr>
                      )}
       
      </MDBTableBody>
    </MDBTable>
           
          </>
          
        )
    }
}


